var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCenterBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 709,
    height: 396,
    viewBox: "0 0 709 396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#f90;stroke-linecap:round;stroke-width:4px;}.b{fill:#fff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 27.5,
    width: 709,
    height: 351,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-605.5 -216)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 382,
    transform: "translate(630 228)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 605.5, 216)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 700,
    height: 342,
    transform: "translate(4.5 32)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 54,
    transform: "translate(620 547.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.5 20)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 50,
    transform: "translate(1285.5 198)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 28,
    transform: "translate(1257.5 198)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.5 4)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 660,
    transform: "translate(660.5 606)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(660.5 224)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 382,
    transform: "translate(659.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 658
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterBox);
export default __webpack_public_path__ + "static/media/center-box.314071fa.svg";
export { ForwardRef as ReactComponent };